import CheckIcon from './Check'
import Spinner from './Spinner'

export default {
    CheckIcon,
    Spinner
}
